import axios from "axios";
import { demoAdapter } from "@/lib/demoApi";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE });
const TOKEN_KEY = "gt_token";

export const tokenStore = {
  get: () =>
    localStorage.getItem(TOKEN_KEY) ||
    sessionStorage.getItem(TOKEN_KEY),

  set: (t, remember = false) => {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);

    if (remember) {
      localStorage.setItem(TOKEN_KEY, t);
    } else {
      sessionStorage.setItem(TOKEN_KEY, t);
    }
  },

  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
  },
};

api.interceptors.request.use((c) => {
  // Mode demo hanya menggunakan API simulasi lokal di browser.
  if (
    typeof window !== "undefined" &&
    window.sessionStorage.getItem("gt_demo_mode") === "1"
  ) {
    c.adapter = demoAdapter;
    if (c.headers) {
      delete c.headers.Authorization;
      delete c.headers.authorization;
    }
    return c;
  }

  // Login pelanggan biasa tetap menggunakan API produksi.
  const t = tokenStore.get();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config?.url?.includes("/auth/login")) {
      tokenStore.clear();
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Terjadi kesalahan. Coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace("Value error, ", "") : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const wsUrl = () => `${API_BASE.replace(/^http/, "ws")}/ws?token=${encodeURIComponent(tokenStore.get() || "")}`;

export async function download(url, params, filename) {
  const r = await api.get(url, { params, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
